import { afterNextRender, inject, Injectable, Injector } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollResetService {
  private router = inject(Router);
  private injector = inject(Injector);

  init(getScrollEl: () => HTMLElement | null): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        // `afterNextRender` takes the injector as an option; the
        // `runInInjectionContext` wrapper around it was doing nothing the
        // option does not.
        afterNextRender(
          () => {
            const el = getScrollEl();
            if (el) el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            else window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          },
          { injector: this.injector }
        );
      });
  }
}
